<script>
    import { fade , scale } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import { _ } from "svelte-i18n";
    import { onMount , createEventDispatcher } from 'svelte';
    import Preloader from './Preloader.svelte';

    let isLoading = false;

    let dispatch = createEventDispatcher();

    export let popupActive = false;
    export let comparedPrice = 0;
    export let currency = '';
    let search_term = '';
    
    let products = [];


    const chooseProduct = (product) => {
        dispatch('selectProduct',product);
    }

    onMount(()=>{
        handleSubmit();
    })


    const handleSubmit = async () => {

        isLoading = true;


        let formData = {
            url : ajax_object.ajax_url,
            search_term : search_term,
            action : 'returns_search_products',
            security: ajax_object.returns_search_products_nonce,
            token : ajax_object.token || ''
        }       

        const data = await fetchData(formData);
        data.products = data.products.map((product)=>{
            product.price = parseFloat(product.price);
            return product;
        })

        products = data.products;

        isLoading = false;
        


    }
</script>   
{#if popupActive}
<Preloader {isLoading}></Preloader>
<div class="returns-popup" transition:fade={{ delay: 250, duration: 300 }}>
    <div class="returns-popup-flex">
        <div class="returns-popup-top">            
            <div class="returns-popup-title">{$_('popup.title')}</div>  
            <div class="returns-popup-close" on:click={()=> { dispatch('closePopup')}}><i class="fa-solid fa-xmark"></i></div>  
        </div>
        <form class="returns-popup-search" on:submit|preventDefault={handleSubmit}>
            <input type="text" placeholder="{$_('popup.input_placeholder')}" bind:value={search_term}><button type="submit">{$_('popup.search_button')}</button>
        </form>
        <div class="returns-popup-content">
            {#each products as product}
            <div>
                <div class="returns-popup-product-top">
                    <div class="returns-popup-product-image"><img src="{product.image}"></div>
                    <div class="returns-popup-product-name">{product.name}</div>
                    <div class="returns-popup-product-price">
                        <div>{product.price}{currency}</div>           
                        {#if comparedPrice >0}
                        <div class="compare_notice">{#if comparedPrice < product.price} {$_('popup.difference_payment')} { product.price - comparedPrice }{currency} {/if}</div>
                        {/if}
                    </div>
                </div>
                <div class="returns-popup-product-bottom">
                    <button class="returns-popup-product-button" on:click={chooseProduct(product)}>{$_('popup.choose_product')}</button>
                </div>
            </div>
            {/each}
        </div>
    </div>
</div>
{/if}